<!--首页-->
<template>
  <div class="gray-back" style="height: 100%">
    <div class="box"  >
      <div class="row1" v-for="(row,i) in list"  v-if="i<1">
        <img v-rblink="{name:'NewsList',query:{cate_id:row.id}}" :src="row.pic_url" />
      </div>
      <div class="row3">
        <img  v-rblink="{name:'NewsList',query:{cate_id:row.id}}" v-for="(row,i) in list"  v-if="i>=1&&i<6" :src="row.pic_url" />
      </div>
      <div class="row1" style="margin: 0px 30px;" v-for="(row,i) in list"  v-if="i==6">
        <img v-rblink="{name:'NewsList',query:{cate_id:row.id}}" :src="row.pic_url" />
      </div>
    </div>
  </div>
</template>
<style scoped>

.box {
  background: #f8f8f8;
  padding-bottom: 50px;
  overflow: hidden;
}
  .row1{
    /*padding: 10px;*/
    margin: 0 10px;
  }
  .row1 img{
    width: 100%;
    margin: 10px 0 0 0 ;
  }
  .row3{
    /*display: flex;*/
    /*align-items: center;*/
    /*justify-content: space-between;*/
    margin: 10px 10px;
    /*flex-wrap: wrap;*/
  }
  .row3 img{
    float: left;
    width: calc(33.33% - 10px);
    margin: 0 10px 10px 0;
  }

</style>

<script>
import Vue from "vue";
import { Tab, Tabs, List, PullRefresh, Toast } from "vant";
Vue.use(Tab)
  .use(Tabs)
  .use(PullRefresh)
  .use(List)
  .use(Toast);

export default {
  name: "NewsList",
  components: {
  },

  data: function() {
    return {
      isLoading: false,
      loading: false,
      finished: false,
      active: 0,
      activeTab: [
      ],
      list:[],
      params:{
        parent_id:30
      },
    };
  },
  filters: {
  },
  mounted() {
    document.title = "机构设置";
    this.fetch();
  },
  destroyed() {},
  methods: {
    fetch() {
      let that = this;
      that.$api.get(
              "/api/cms/catelist",
              that.params,
              res => {
                that.list = res.data
              },
              res => {
                Toast(res.msg);
              }
      );
    },
  }
};
</script>



// WEBPACK FOOTER //
// Jigoushezhi.vue?a7112dfa